import { Box, Flex } from '@mantine/core'
import { GateLearnItemStyled, PriceLearnTagStyled } from './style'
import { Tag } from '@gate/gui'
import { FC, useEffect, useRef, useState } from 'react'
import type { GateLearnItem } from 'api-price'
import { eventTracker } from '@/utils/collectEvent'
import BaseImage from '@/components/BaseImage'
import BaseTooltip from '@/components/BaseTooltip'
import { formatTimeCode } from '@/utils/tools'
import { useIsGtSm } from '@/components/Adapter'
import useLangPrefix from '@/hooks/useLangPrefix'

const GateLearnLiItem: FC<GateLearnItem & { borderState: boolean }> = ({
  borderState,
  title,
  banner,
  introduction,
  updated_at,
  topic_tag,
  url_text,
  id,
}) => {
  const { langPrefix } = useLangPrefix()
  const isGtSm = useIsGtSm()
  const priceRefs = useRef(null) as any
  const [isTextOverflowing, setIsTextOverflowing] = useState(true)

  useEffect(() => {
    if (priceRefs?.current) {
      const result = priceRefs?.current?.scrollHeight > priceRefs?.current?.clientHeight
      setIsTextOverflowing(result)
    }
  }, [])
  return (
    <GateLearnItemStyled
      data-border={String(borderState)}
      onClick={() => {
        const gateLearnItemUrl = `${langPrefix}/learn/articles/${url_text}/${id}`
        eventTracker('price_sectors_click', {
          gate_learn_url: gateLearnItemUrl,
        })
        window.open(gateLearnItemUrl, '_blank')
      }}
    >
      <Flex gap={8} mb={16}>
        <BaseImage
          className="price-learn-item--image"
          width={88}
          height={88}
          style={{ borderRadius: '8px', minWidth: '88px' }}
          src={banner}
        />

        <Flex direction="column" gap={8} maw={'calc(100% - 96px)'}>
          <BaseTooltip label={title ?? ''}>
            <span className="text-1 size-16 font-700 line-120">{title ?? '--'}</span>
          </BaseTooltip>

          <Box
            component="span"
            className="text-2 size-14 font-400 line-150"
            sx={{
              whiteSpace: 'pre-wrap',
              display: '-webkit-box',
              '-webkit-box-orient': 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              '-webkit-line-clamp': isGtSm ? '3' : '2',
              height: isTextOverflowing ? (isGtSm ? 'calc(1.5em * 3)' : 'calc(1.5em * 2)') : 'auto',
              lineHeight: '1.5em',
            }}
          >
            {introduction ?? '--'}
          </Box>
        </Flex>
      </Flex>

      <Flex justify="space-between" align="center" gap={8}>
        <PriceLearnTagStyled>
          <Flex gap={8} align="center" w="max-content">
            {topic_tag &&
              `${topic_tag}`?.split(',').map(item => <Tag key={item} label={item ?? '--'} bg="var(--color-cmpt-11)" />)}
          </Flex>
        </PriceLearnTagStyled>

        <time className="size-12 font-400 text-3">{formatTimeCode(updated_at)}</time>
      </Flex>
    </GateLearnItemStyled>
  )
}

export default GateLearnLiItem
